import {Injectable} from '@angular/core';
import {HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {AuthService} from "../services/auth/auth.service";
import {ApiResponse} from "../api/api-response";
import {Router} from "@angular/router";
import {SnackbarService} from "../services/snackbar/snackbar.service";
import {LoaderService} from "../services/loader/loader.service";

export const SILENT_ERRORS = new HttpContextToken<boolean>(() => false);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router,
    private snackbar: SnackbarService,
    private loader: LoaderService
  ) {
  }

  intercept(request: HttpRequest<any>, handler: HttpHandler): Observable<HttpEvent<any>> {
    if (request.context.get(SILENT_ERRORS)) {
      return handler.handle(request);
    }

    return handler.handle(request).pipe(
      catchError((response) => this.errorHandler(response))
    );
  }

  errorHandler(response: HttpErrorResponse) {
    let message = response.error ? response.error.message ?? response.message : response.message;

    switch (response.status) {
      case 401:
        if (!this.router.url.startsWith('/login')) {
          this.authService.logout();
        }
        break;
      case 403:
        this.snackbar.error('Access denied.');
        this.router.navigateByUrl('/').then();
        break;
      default:
        if (response.status >= 400) {
          this.snackbar.error(message, response.error.data ?? null);
        }
        break;
    }

    const error = new ApiResponse(
      response.status,
      false,
      message,
      response.error ? response.error.data ?? null : null
    );

    console.error(error);

    this.loader.stopLoading()

    return throwError(() => error);
  }
}
